const TOKEN_KEY = 'auth_token';
const TOKEN_EXPIRE_KEY = 'auth_token_expire';

export function getToken () {
  return localStorage.getItem('auth_token');
}

// 设置 token（登录成功后调用）
export function setToken(token, expires) {
  localStorage.setItem(TOKEN_KEY, token);
  if (expires) {
    localStorage.setItem(TOKEN_KEY_EXPIRE, expires); // 存储过期时间戳（如：后端返回的 expires_in）
  }
}

// 移除 token（登出时调用）
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXPIRE_KEY);
}

// 检查 token 是否过期
export function checkTokenExpired() {
  const expire = getTokenExpire();
  if (!expire) return false; // 无过期时间，视为有效（根据业务调整）
  return Date.now() > Number(expire); // 当前时间 > 过期时间 → 过期
}

// 获取过期时间
export function getTokenExpire() {
  return localStorage.getItem(TOKEN_EXPIRE_KEY);
}